import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';

const CANONICAL_BASE = process.env.REACT_APP_CANONICAL_BASE || 'https://cyberate.investments';
const INDEXABLE = process.env.REACT_APP_INDEXABLE === '1';

const DEFAULT_DESCRIPTION =
  'Cyberate Investments Pty Ltd is an Adelaide-based development and investment company focused on property, built-environment businesses and enabling innovation.';

const SEO = ({ title, description, path, noindex, schema }) => {
  const canonical = path ? `${CANONICAL_BASE}${path === '/' ? '/' : path}` : undefined;
  const robots = noindex || !INDEXABLE ? 'noindex, follow' : 'index, follow';

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{title}</title>
      <meta name="robots" content={robots} />
      <meta name="description" content={description || DEFAULT_DESCRIPTION} />
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      {canonical && <link rel="canonical" href={canonical} />}
      {/* Only en-AU is declared. zh.js currently covers the global layer only and
          page-level content falls back to English, so a zh-CN alternate would
          announce an equivalent page that does not exist (06 §2.5 / X06). */}
      {canonical && <link rel="alternate" hreflang="en-AU" href={canonical} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description || DEFAULT_DESCRIPTION} />
      <meta property="og:type" content="website" />
      {canonical && <meta property="og:url" content={canonical} />}
      {schema &&
        schema.map((item, i) => (
          <script key={i} type="application/ld+json">
            {JSON.stringify(item)}
          </script>
        ))}
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  path: PropTypes.string,
  noindex: PropTypes.bool,
  schema: PropTypes.array,
};

export default SEO;
